import sessionStore from 'services/session_store';

const cookieName = 'active_brand';

export const setActiveBrand = (activeBrand) => {
  sessionStore.set(cookieName, activeBrand);
};

export const getActiveBrand = () => {
  return sessionStore.get(cookieName);
};

export const deleteActiveBrand = () => {
  return sessionStore.delete(cookieName);
};
